import { useWindowSize } from "@vueuse/core";
import { useQuasar } from "quasar";
import { computed } from "vue";

export const useScreenSize = () => {
    //https://github.com/quasarframework/quasar/issues/18092
    const { screen } = useQuasar();
    const { width, height } = useWindowSize();

    const isXSmall = computed(() => {
        return screen.name === "xs";
    });

    const isSmall = computed(() => {
        return screen.name === "sm";
    });

    const isLessThanMedium = computed(() => {
        return screen.lt.md;
    });

    const isLessThanLarge = computed(() => {
        return screen.lt.lg;
    });

    const isLargerThanSmall = computed(() => {
        return screen.gt.sm;
    });

    const isLargerThanMedium = computed(() => {
        return screen.gt.md;
    });

    const isMedium = computed(() => {
        return screen.name === "md";
    });

    const isLarge = computed(() => {
        return screen.name === "lg";
    });

    const isLandscape = computed(() => {
        return width.value > height.value;
    });

    return {
        isXSmall,
        isSmall,
        isLessThanMedium,
        isLessThanLarge,
        isLargerThanMedium,
        isLargerThanSmall,
        isMedium,
        isLarge,
        isLandscape,
    };
};
